<script lang="ts" setup>
import { computed } from 'vue'

import { TagList, TagItem } from '@toni/brand-ui'

interface Tag {
  name: string
  url: string
}
interface PageBody {
  mainStructurePath?: Tag[]
  additionalStructures?: Tag[]
}

const props = defineProps<{
  pageData?: PageBody,
  brand?: string
}>()

const filterValidTags = (tags: Tag[]): Tag[] => {
  return tags.filter(tag => tag.name && tag.url && tag.url !== '/')
}

const removeDuplicateTags = (tags: Tag[]): Tag[] => {
  const seen = new Set<string>()
  return tags.filter(tag => {
    const duplicate = seen.has(tag.name)
    seen.add(tag.name)
    return !duplicate
  })
}

const combinedTags = computed((): Tag[] => {
  if (props.pageData) {
    const mainTags = props.pageData.mainStructurePath ?? []
    const additionalTags = props.pageData.additionalStructures ?? []
    const combined = [...mainTags, ...additionalTags]
    const validTags = filterValidTags(combined)
    return removeDuplicateTags(validTags)
  }
  return []
})

const showTagList = computed((): boolean => {
  return props.brand ? props.brand !== 'todaysgolfer' : true
})
</script>

<template>
  <TagList v-if="showTagList && combinedTags.length > 0">
    <TagItem v-for="(tag, index) in combinedTags"
             :key="index"
             :href="tag.url"
             rel="follow">
      {{ tag.name }}
    </TagItem>
  </TagList>
</template>
